import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { ClienteRelatorio, RelatorioDinamicoService } from 'src/app/services/relatorio-dinamico.service';

export function formatarDocumento(cnpj: string): string {
  const d = (cnpj || '').replace(/\D/g, '');
  if (d.length === 14) {
    return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }
  if (d.length === 11) {
    return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  }
  return cnpj;
}

@Component({
  selector: 'habil-busca-clientes',
  templateUrl: './busca-clientes.component.html',
  styleUrls: ['./busca-clientes.component.scss'],
})
export class BuscaClientesComponent implements OnChanges {
  @Input() cnpjs: string[] = [];
  @Input() disabled = false;
  @Input() inputId: string;
  @Output() cnpjsChange = new EventEmitter<string[]>();
  @ViewChild(AutoComplete) auto: AutoComplete;

  selecionados: ClienteRelatorio[] = [];
  sugestoes: ClienteRelatorio[] = [];
  erro = '';
  formatar = formatarDocumento;

  private conhecidos = new Map<string, ClienteRelatorio>();

  constructor(private service: RelatorioDinamicoService) {}

  ngOnChanges(): void {
    const lista = this.cnpjs || [];
    if (lista.join(',') === this.selecionados.map((c) => c.cnpj).join(',')) {
      return;
    }
    this.selecionados = lista.map((cnpj) => this.conhecidos.get(cnpj) || { cnpj });
    this.completar(lista.filter((cnpj) => !this.conhecidos.has(cnpj)));
  }

  buscar(texto: string): void {
    this.service.buscarClientes(texto).subscribe(
      (lista) => {
        this.erro = '';
        lista.forEach((c) => this.conhecidos.set(c.cnpj, c));
        this.sugestoes = lista;
      },
      (e) => {
        this.sugestoes = [];
        this.erro = 'Não foi possível buscar os clientes: ' + this.service.mensagemErro(e);
      }
    );
  }

  alterar(lista: ClienteRelatorio[]): void {
    this.selecionados = lista || [];
    this.cnpjsChange.emit(this.selecionados.map((c) => c.cnpj));
  }

  tecla(evento: KeyboardEvent): void {
    if (evento.key !== 'Enter') {
      return;
    }
    const campo = evento.target as HTMLInputElement;
    const partes = (campo.value || '').split(/[\s,;]+/).map((p) => p.replace(/\D/g, '')).filter((p) => p);
    if (!partes.length || partes.some((p) => p.length !== 11 && p.length !== 14)) {
      return;
    }
    const novos = partes.filter((p) => !this.selecionados.some((c) => c.cnpj === p));
    campo.value = '';
    this.auto?.hide();
    if (!novos.length) {
      return;
    }
    this.alterar([...this.selecionados, ...novos.map((cnpj) => this.conhecidos.get(cnpj) || { cnpj })]);
    this.completar(novos.filter((cnpj) => !this.conhecidos.has(cnpj)));
  }

  detalhe(c: ClienteRelatorio): string {
    if (!c.nome) {
      return 'Sem cadastro na Central';
    }
    return c.host ? `banco ${c.banco} em ${c.servidor || c.host}` : `banco ${c.banco}, servidor fora do cadastro de bancos`;
  }

  private completar(cnpjs: string[]): void {
    if (!cnpjs.length) {
      return;
    }
    this.service.clientesPorCnpj(cnpjs).subscribe((lista) => {
      lista.forEach((c) => this.conhecidos.set(c.cnpj, c));
      cnpjs.filter((cnpj) => !this.conhecidos.has(cnpj)).forEach((cnpj) => this.conhecidos.set(cnpj, { cnpj }));
      this.selecionados = this.selecionados.map((c) => this.conhecidos.get(c.cnpj) || c);
    });
  }
}
